module.exports = __webpack_public_path__ + "media/images/solution2-91b2d15cdc324745ad61b5413a3a3768.svg";